import { StatusBadge } from "@nexxt/ui";
import type { Ref } from "react";

// The lines of a linesheet as Backstage shows them: the picture the hero zooms out of (ADR-286). Made-up brands.
const lines = [
  { code: "ARV-SS27-0108", name: "Linen overshirt", colour: "Sand", sizes: "S–XL", price: "€ 96.00", ready: true },
  { code: "ARV-SS27-0115", name: "Pleated trouser", colour: "Ink", sizes: "44–54", price: "€ 88.00", ready: true },
  { code: "ARV-SS27-0121", name: "Merino crew", colour: "Ecru", sizes: "S–XL", price: "€ 74.00", ready: true },
  { code: "SLV-SS27-0412", name: "Silk slip dress", colour: "Moss", sizes: "36–44", price: "€ 142.00", ready: false },
  { code: "SLV-SS27-0418", name: "Cropped jacket", colour: "Chalk", sizes: "36–44", price: "€ 168.00", ready: true },
  { code: "SLV-SS27-0423", name: "Wide knit skirt", colour: "Rust", sizes: "XS–L", price: "€ 82.00", ready: false },
  { code: "LMN-SS27-0031", name: "Canvas tote", colour: "Natural", sizes: "One", price: "€ 39.00", ready: true },
  { code: "LMN-SS27-0036", name: "Leather loafer", colour: "Cognac", sizes: "39–45", price: "€ 129.00", ready: true },
];

/** The line the story starts from: the hero measures its code to zoom out of it. */
const focusLine = 3;

export function LinesheetGrid({ focusRef }: { focusRef?: Ref<HTMLSpanElement> }) {
  return (
    <div className="mock-grid">
      <div className="mock-grid-title">
        <strong>Selva · SS27 linesheet</strong>
        <span>{lines.length * 31} SKUs</span>
      </div>
      <div className="mock-grid-row is-head">
        <span>Style</span>
        <span>Name</span>
        <span>Colour</span>
        <span>Sizes</span>
        <span>Wholesale</span>
        <span>Status</span>
      </div>
      {lines.map((line, i) => (
        <div key={line.code} className="mock-grid-row" data-focus={i === focusLine || undefined}>
          <span className="font-mono" ref={i === focusLine ? focusRef : undefined}>
            {line.code}
          </span>
          <span>{line.name}</span>
          <span>{line.colour}</span>
          <span>{line.sizes}</span>
          <span className="tabular-nums">{line.price}</span>
          <span>
            <StatusBadge tone={line.ready ? "success" : "warning"} label={line.ready ? "Ready" : "Prices to set"} />
          </span>
        </div>
      ))}
    </div>
  );
}
